import { css } from '@emotion/css';

export const missingInputValidationCx = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 0.5rem;

  .illustration {
    display: flex;
    margin-bottom: 1rem;
    width: 100%;
  }

  p {
    text-align: center;
  }
`;
